import React from 'react'

interface FormFieldDescriptionProps {
  text: string
}

export const FormFieldDescription: React.FC<FormFieldDescriptionProps> = ({
  text,
}) => <p className="mt-1 text-sm text-gray-600">{text}</p>
